// Helpers to keep every dropdown/option list sorted alphabetically (A→Z).
// Uses locale-aware, case-insensitive, numeric-aware comparison so that
// values like "Item 2" sort before "Item 10".

const collator = new Intl.Collator(undefined, {
  numeric: true,
  sensitivity: "base",
});

/** Compare two values as strings (alphabetical, case-insensitive, numeric-aware). */
export function compareAlpha(a, b) {
  return collator.compare(String(a ?? ""), String(b ?? ""));
}

/**
 * Return a new array sorted alphabetically.
 * @param {Array} list - source array (not mutated)
 * @param {Function} [getLabel] - maps an item to the string used for sorting.
 *   Defaults to the item itself (for arrays of strings) or its `label` field.
 */
export function sortByLabel(list, getLabel) {
  if (!Array.isArray(list)) return list;
  const label =
    getLabel ||
    ((o) => (o && typeof o === "object" ? o.label ?? o.name ?? "" : o));
  return [...list].sort((a, b) => compareAlpha(label(a), label(b)));
}

export default sortByLabel;
